import { combineReducers } from 'redux';
import { UserAuthenticationReducer } from 'Data/Reducers/UserAuthenticationReducer';
import { SearchReducer } from 'Data/Reducers/SearchReducer';
import { UserRegistrationReducer } from 'Data/Reducers/UserRegistrationReducer';
import { CartReducer } from 'Data/Reducers/CartReducer';
import { AccountModeModalReducer } from 'Data/Reducers/AccountModeModalReducer';
import { AuthBannerReducer } from 'Data/Reducers/AuthBannerReducer';
import { UnauthorizedPopupReducer } from 'Data/Reducers/UnauthorizedPopupReducer';
import { DeliveryAddressesReducer } from 'Data/Reducers/DeliveryAddressesReducer';
import { OrderReducer } from 'Data/Reducers/OrderReducer';

export const rootReducer = combineReducers({
  userAuthenticationReducer: UserAuthenticationReducer,
  userRegistrationReducer: UserRegistrationReducer,
  searchReducer: SearchReducer,
  cartReducer: CartReducer,
  accountModeModalReducer: AccountModeModalReducer,
  authBannerReducer: AuthBannerReducer,
  unauthorizedPopupReducer: UnauthorizedPopupReducer,
  deliveryAddressesReducer: DeliveryAddressesReducer,
  orderReducer: OrderReducer,
});

export type RootReducerState = ReturnType<typeof rootReducer>;
